import { render, staticRenderFns } from "./EducationalItemViewList.vue?vue&type=template&id=3fd51be8&scoped=true&"
import script from "./EducationalItemViewList.vue?vue&type=script&lang=js&"
export * from "./EducationalItemViewList.vue?vue&type=script&lang=js&"
import style0 from "./EducationalItemViewList.vue?vue&type=style&index=0&id=3fd51be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd51be8",
  null
  
)

export default component.exports